module.exports = __webpack_public_path__ + "static/media/MSW_02.9d5adf62.jpg";